import { LIGHT_SILVER, WHITE } from "./colors.jsx";
export const THEMES = {
  LIGHT_THEME: {
    primary: WHITE,
    secondary: LIGHT_SILVER,
  },
};
